module.exports = __webpack_public_path__ + "fonts/Quarca-NorBol.87718b29.woff2";